import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/AuthenticationService';

@Component({ standalone:false,
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {

  constructor(public router:Router, private authService:AuthenticationService) { }

  public goHome(): void {
    //customer-dashboard
    //admin-dashboard
    //login
    if(this.authService.currentUserValue){
      if(this.authService.customerContext){
        this.router.navigate(['/home/customer-dashboard']);
      }
      else if(this.authService.vendorContext){
        this.router.navigate(['/home/vendor-dashboard']);
      }
      else if (this.authService.isSuperAdmin){
        this.router.navigate(['/home/admin-dashboard']);
      }
      else{
        this.router.navigate(['/login']);
      }
    } 
    else{
      this.router.navigate(['/login']);
    }
  }
}
